'use client';
import { useEffect } from 'react';
import { useAmplitude } from './amplitude';
import { useStore } from '@/store/store';
import { useSnowplowUm } from '@/tracking/snowplow';

export type TrackingEvent = {
    destination: 'amplitude' | 'snowplow' | 'gtm';
    eventProps: any;
};

export const TrackingManager = () => {
    const { sendEventToAmplitude } = useAmplitude();
    const { sendEventToSnowplow } = useSnowplowUm();
    // const { sendEventToGTM } = useGTM();
    // ...
    const { setSendEvent } = useStore((state) => state.tracking);

    const sendEvent = (events: TrackingEvent[]) => {
        events.forEach((event) => {
            switch (event.destination) {
                case 'amplitude':
                    sendEventToAmplitude(event.eventProps);
                    break;
                case 'snowplow':
                    sendEventToSnowplow(event.eventProps);
                    break;
                // case 'gtm':
                //     sendEventToGTM(event.gtm);
                //     break;
                // default:
                //     console.warn(`[Tracking] Unknown event destination: ${event.destination}`);
            }
        });
    };

    useEffect(() => {
        setSendEvent(sendEvent);
    }, []);

    return <></>;
};
